import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import { LEGAL_PAGES } from '../data/meta'

export default function Disclaimer() {
  const page = LEGAL_PAGES.disclaimer
  return (
    <>
      <SEO title={page.title} description={page.description} canonical={page.url} structuredData={{ '@context': 'https://schema.org', '@type': 'WebPage', name: page.title, description: page.description }} />
      <Navbar />
      <div className="legal-page">
        <div className="legal-page-content">
          <h1>Disclaimer</h1>
          <p>Last updated: July 2026</p>

          <h2>1. AI-Generated Content</h2>
          <p>
            TRED-EX AI features generate automated suggestions. Outputs may be incomplete or inaccurate.
            Always verify critical information before acting on it.
          </p>

          <h2>2. Limitation of Liability</h2>
          <p>
            Tredex Technology shall not be liable for indirect, incidental, or consequential damages arising from use of our services.
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}
